import { lazy } from "react";
import { isChunkLoadError, shouldReloadForNewBuild } from "./chunkReload";

const LAST_RELOAD_KEY = "ros:chunk-reload-at";

function readLastReload() {
  try {
    return Number(window.sessionStorage.getItem(LAST_RELOAD_KEY)) || null;
  } catch {
    return null;
  }
}

function reloadForNewBuild() {
  try {
    window.sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
  } catch {
    // Storage blocked: the reload still happens, just without the loop guard.
  }
  window.location.reload();
}

/**
 * A page loaded the first time it is visited, instead of in the main bundle.
 * If its chunk is gone because a deploy replaced it, reload once to get the new
 * build; any other failure is rethrown for the error boundary.
 */
export function lazyPage(importPage) {
  return lazy(() =>
    importPage().catch((error) => {
      if (isChunkLoadError(error) && shouldReloadForNewBuild(readLastReload(), Date.now())) {
        reloadForNewBuild();
        return new Promise(() => {});
      }
      throw error;
    })
  );
}
